import React from 'react';
import '../styling/topNav.css';
import logo from '../assets/Alliedlogo.png';

const TopNav = ({ onBack, onHome, onSettings, onOutcomes, onLogout }) => {
  return (
    <div className="top-nav">
      <div className="top-nav-left">
        <img src={logo} alt="Allied OMS" className="brand-logo" />
        <div className="brand-text">
          <span className="brand-title">Quality Improvement Reporting</span>
        </div>
      </div>
      <div className="top-nav-right">
        {/* Navigation Group */}
        <div className="nav-group navigation">
          {onBack && <button className="nav-btn secondary" onClick={onBack}>← Back</button>}
          {onHome && <button className="nav-btn secondary" onClick={onHome}>🏠 Home</button>}
        </div>

        {/* Primary Actions Group */}
        <div className="nav-group primary-actions">
          {onOutcomes && <button className="nav-btn primary" onClick={onOutcomes}>📊 Dashboard</button>}
          {onSettings && <button className="nav-btn primary" onClick={onSettings}>⚙️ Settings</button>}
        </div>

        {/* Account Group */}
        <div className="nav-group account">
          {onLogout && <button className="nav-btn logout" onClick={onLogout}>🚪 Logout</button>}
        </div>
      </div>
    </div>
  );
};

export default TopNav;


